import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { Project } from '@src/app/models/project';
/**
 * 
 */
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-projectwizard',
  templateUrl: './projectwizard.component.html',
  styleUrls: ['./projectwizard.component.css']
})
export class ProjectwizardComponent implements OnInit, OnChanges{
  informationtoggle:boolean = true;
  assigntoggle:boolean;
  tagstoggle:boolean;
  fromtemplate:boolean;
  @Output() @Input() project:Project;
  @Input() customerId:string;
  @ViewChild('closeprojectcreation',{static:true}) closeprojectcreation;
  showSpinner:boolean = false;
  @Input() dealId:string;
  @Output() projecttoadd = new EventEmitter<Project>();
  showhelp:boolean = true;
  @Input() tagready : boolean = false; 
  @Input() rolesready : boolean = false; 
  


  constructor(
    private uieventhub:UieventhubService,
    private cdr:ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    //this.project = new Project;
    // if(this.dealId != undefined){
    //   this.project.dealId = this.dealId;
    // }
    // if(this.customerId != undefined){
    //   this.project.customer = this.customerId;
    // }
    this.toggleInfo();
  }
  
  ngOnChanges(changes: SimpleChanges){
    //console.log('changes from wiz',changes);
    if(!this.project){  this.project = new Project; };
    if(changes.dealId && changes.dealId.currentValue && changes.dealId.currentValue != changes.dealId.previousValue){
      this.project.dealId = changes.dealId.currentValue;
      this.dealId = changes.dealId.currentValue;
    }
    if( changes.customerId && changes.customerId.currentValue && changes.customerId.currentValue != changes.customerId.previousValue){
      this.project.customer = changes.customerId.currentValue;
      this.customerId = changes.customerId.currentValue;
    }
  }

  tagsloaded(boolean){
    this.tagready = boolean;
  }

  rolesloaded(boolean){
    this.rolesready = boolean;
  }

  setFromTemplate(set:boolean){
    this.reset();
    this.fromtemplate = set;
  }
  toggleInfo(){
    this.showSpinner = false;
    this.informationtoggle = true;
    this.tagstoggle = false;
    this.assigntoggle = false;
  }
  toggleAssign(){
    this.uieventhub.setAssignProject(this.project.projectId);
    this.showSpinner = false;
    this.assigntoggle = true;
    this.informationtoggle = false;
    this.tagstoggle = false;
  }
  toggleTag(){
    this.showSpinner = false;
    this.tagstoggle = true;
    this.informationtoggle = false;
    this.assigntoggle = false;
  }
  setProject(project:Project){
    this.project = project;
    this.fromtemplate = false;
    this.projecttoadd.emit(this.project);
    this.toggleAssign();
  }
  closeWizard(){
    this.reset();
    this.closeprojectcreation.nativeElement.click();
  }
  reset(){
    this.project = new Project;
    this.informationtoggle = true;
    this.tagstoggle = false;
    this.assigntoggle = false;
    this.showSpinner = false;
    this.cdr.detectChanges();
  }
  setProjectload(boolean){
    this.showSpinner = boolean;
    this.cdr.detectChanges();
  }

  templatelistover(boolean){
    this.fromtemplate = boolean;
    this.showSpinner = boolean;
    this.cdr.detectChanges();
  }
}
